<template>
  <div>
    <div class="breadcrumb">
      <h1 v-if="detail.status_id != 10" style="color: #AC8400;">
        Claim Details: {{ detail.status.name === 'In Process' && detail.product_id === 6 ? 'Assessment in Progress' :
          detail.status.name }}
      </h1>
      <h1 v-else style="color: #AC8400;">
        Claim Details: Pending Document Submission
      </h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>TBA</b> /

      <router-link to="/tba_claim">
        Claims
      </router-link>
      /

      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-2 ml-1" v-if="detail.product_id !== 6">
      <p v-if="detail.status_id != 10 && detail.status_id != 13" style="margin-right: 20px;">
        <b>Officer:</b> {{ detail.staff.user.name }}
      </p>
      <p v-if="detail.status_id != 10" style="margin-right: 20px;">
        <b>Date Taken:</b> {{ detail.counter_date | moment("Do MMMM YYYY") }}
      </p>
      <p v-if="detail.status_id == 6" style="margin-right: 20px;">
        <b>Date Completed:</b> {{ detail.updated_at | moment("Do MMMM YYYY") }}
      </p>
      <p v-if="detail.status_id == 6" style="margin-right: 20px;">
        <b>Status:</b> {{ detail.status.name }}
      </p>
    </div>

    <ul v-if="detail.product_id === 6" class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item">
        <a class="nav-link active" id="home-basic-tab" data-toggle="tab" href="#_details" role="tab"
          aria-controls="_details" aria-selected="true" @click.prevent="setActive('_details')">Details</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" id="profile-basic-tab" data-toggle="tab" href="#_documents" role="tab"
          aria-controls="_documents" aria-selected="false" @click.prevent="setActive('_documents')">Documents</a>
      </li>
      <li class="nav-item" v-if="detail.status.id == 7">
        <a class=" nav-link" id="profile-basic-tab" data-toggle="tab" href="#_declined" role="tab"
          aria-controls="_declined" aria-selected="false" @click.prevent="setActive('_declined')">Decline Letter</a>
      </li>
      <li class="nav-item" v-if="detail.status.id == 6">
        <a class=" nav-link" id="profile-basic-tab" data-toggle="tab" href="#_approved" role="tab"
          aria-controls="_documents" aria-selected="false" @click.prevent="setActive('_approved')">Approved Letter</a>
      </li>
    </ul>

    <div class="tab-content" style="padding: 0" id="myTabContent">
      <div class="tab-pane fade show active" id="_details" role="tabpanel" aria-labelledby="home-basic-tab">
        <div class="row mb-4">
          <div class="col-md-12 card"
            style="margin-left: 15px; margin-right: 15px; border-top-left-radius: 0 !important; border-top-right-radius: 0; border-radius: 10px">
            <div class="tab-content" id="myTabContent">
              <!-- Participant Details -->
              <div class="row">
                <div class="col-md-12 font-weight-bold mb-4" style="font-size: 1.6em; padding-left: 6px;">
                  Participant Details
                </div>

                <div class="col-md-6">
                  <p><b>Name:</b> {{ profile.full_name }}</p>

                  <p><b>IC No.:</b> {{ detail.user ? detail.user.ic_number : '' }}</p>

                  <p>
                    <b>Date of Birth:</b>
                    {{ profile.date_of_birth | moment("Do MMMM YYYY") }}
                  </p>

                  <div>
                    <p><b>Gender:</b> {{ profile.gender }}</p>
                  </div>

                  <div>
                    <p><b>Marital Status:</b> {{ profile.marital_status }}</p>
                  </div>

                  <p><b>Nationality:</b> {{ profile.nationality }}</p>

                  <!-- <p>
              <b>Race:</b> {{ detail.race }}
            </p> -->

                  <p><b>Religion:</b> {{ profile.religion }}</p>

                  <p><b>Email:</b> {{ detail.user ? detail.user.email : '' }}</p>
                </div>

                <div class="col-md-6">
                  <!-- no longer required? -->
                  <!-- <p>
              <b>Customer Code:</b> {{ detail.cfid }}
            </p> -->

                  <p>
                    <b>Registration Date:</b>
                    {{ detail.created_at | moment("Do MMMM YYYY, h:mm:ss a") }}
                  </p>

                  <p><b>Occupation:</b> {{ profile.occupation }}</p>

                  <p><b>Mobile No.:</b> {{ profile.mobile_number }}</p>

                  <!-- <p>
              <b>Office No.:</b> {{ detail.office_number }}
            </p> -->

                  <p>
                    <b>Address:</b>
                    <span>{{
                      profile.address1 +
                      checkNull(profile.address2) +
                      checkNull(profile.address3) +
                      checkNull(profile.kampong)
                    }}</span>
                  </p>

                  <p><b>Postal Code:</b> {{ profile.postal_code }}</p>

                  <p><b>Office Address:</b> {{ profile.office_address }}</p>
                </div>
              </div>

              <div class="mt-3 mb-4 border-top"></div>

              <!-- Claim Details -->
              <div class="row">
                <div class="col-md-12 font-weight-bold mb-4" style="font-size: 1.6em; padding-left: 6px;">
                  Claim Details
                </div>

                <div class="col-md-4">
                  <!-- Reference ID ani apa? -->
                  <p><b>Reference ID:</b> {{ detail.claim_intimation_number }}</p>

                  <p><b>Product:</b> {{ detail.product.name }}</p>

                  <p>
                    <span v-if="detail.certificate_number != null"><b>Certificate No.:</b> {{ detail.certificate_number
                    }}
                    </span>
                    <span v-else><b>Certificate No.:</b> </span>
                  </p>

                  <p v-if="detail.product_id == 6">
                    <span v-if="getPersonCovered">
                      <b>Person Covered:</b> {{ getPersonCovered.meta_value }}
                    </span>
                    <span v-else>
                      <b>Person Covered:</b>
                    </span>
                  </p>

                  <p>
                    <span v-if="detail.certificate_number != null"><b>Valid From:</b>
                      {{ detail.certificate_start_date | moment("Do MMMM YYYY") }}
                    </span>
                    <span v-else><b>Valid From:</b> </span>
                  </p>

                  <p>
                    <span v-if="detail.certificate_number != null"><b>Valid Until:</b>
                      {{ detail.certificate_expiry_date | moment("Do MMMM YYYY") }}
                    </span>
                    <span v-else><b>Valid Until:</b> </span>
                  </p>

                  <p v-if="detail.product_id !== 6">
                    <span v-if="detail.status_id == 10"><b>Void Remarks:</b>
                      <textarea class="form-control" v-model="void_remarks"></textarea>
                    </span>
                    <span v-if="detail.status_id == 13">
                      <b>Void Remarks:</b>
                      {{ detail.void_remarks }}
                    </span>
                  </p>
                  <p>
                    <span v-if="detail.status_id == 13">
                      <b>Void By:</b>
                      {{ detail.void_by.user.name }}
                    </span>
                  </p>
                </div>

                <div class="col-md-4">
                  <p>
                    <!-- <b>Claim Type:</b> {{ detail.benefit.name }} -->
                  </p>

                  <p>
                    <b>Incident Date:</b>
                    {{ detail.incident_date | moment("Do MMMM YYYY") }}
                  </p>

                  <p>
                    <span><b>Notification Date:</b>
                      {{ detail.created_at | moment("Do MMMM YYYY, h:mm:ss a") }}
                    </span>
                  </p>

                  <p v-if="detail.product_id != 6">
                    <b>Description of loss:</b>
                    <span v-for="(loss, index) in detail.losses" v-bind:key="index">
                      <span v-if="loss.loss !== 'Others'">
                        <br />
                        - {{ loss.loss }}
                      </span>
                      <span v-else>
                        <br />
                        - Others: {{ detail.other }}
                      </span>
                    </span>
                  </p>
                  <div v-if="detail.product_id == 6">
                    <b>Type of Claim:</b>
                    <p>
                      - {{ detail.benefit.name }}
                    </p>

                  </div>
                  <div v-if="detail.product_id == 6">
                    <b>Please provide the incident details:</b>
                    <p>{{ detail.description }}</p>


                  </div>
                </div>

                <div class="col-md-4">
                  <p v-if="detail.product_id != 6">
                    <b>Deadline to submit to Counter:</b>
                    {{ detail.deadline_date | moment("Do MMMM YYYY") }}
                  </p>
                  <p class="d-flex deadline-text" v-if="detail.product_id == 6">
                    <b style="margin-right: 20px;">
                      Deadline to submit complete documentation:
                    </b>
                  <div v-if="detail.product_id === 6">
                    <datepicker style="border: none; max-width: 250px;" format="DD/MM/YYYY"
                      @change="(e) => handleDateChange(e)" v-if="detail.status_id == 10 || detail.status_id === 4"
                      v-model="deadline_date" width="250px">
                    </datepicker>
                    <span v-else>
                      {{ detail.deadline_date | moment("Do MMMM YYYY") }}
                    </span>
                  </div>

                  <div v-if="deadlineError" class="text-danger row">
                    <div class="col-6 w-100"></div>
                    <div class="col-6 w-100" style="padding-left: 25px;">Deadline required</div>
                  </div>
                  </p>

                  <p v-if="detail.product_id !== 6">
                    <b>Date submit form at Counter:</b>
                    <datepicker format="DD/MM/YYYY" v-if="detail.status_id == 10" v-model="counter_date" width="300px">
                    </datepicker>
                    <span v-else>
                      {{ detail.counter_date | moment("Do MMMM YYYY") }}</span>
                  </p>

                  <p v-if="detail.claim_payment && detail.claim_payment.payment_date != null"><b>Method Payment:</b> {{
                    detail.claim_payment.payment_type_text }} {{ detail.claim_payment.payment_method_text ==
                      "Online Transfer" ? "paid on" : "collect on" }} {{
                      moment(detail.claim_payment.payment_date).format("Do MMMM YYYY") }}</p>

                  <p v-if="detail.product_id === 6">
                    <b>Status:</b> <span>
                      <div v-if="detail.claim_payment && detail.claim_payment.status === 2">Settled and Closed</div>
                      <div v-else-if="detail.document_complete" class="text-success">{{ detail.status.id === 14 ?
                        detail.status.name : 'Complete Document' }}</div>
                      <div v-else class="text-danger">Incomplete Document</div>
                    </span>
                  </p>

                  <p v-if="detail.product_id == 2">
                    <span v-if="meta.length > 0"><b>Download Images:</b> <br />
                      <button class="btn btn-lg btn-success" @click="downloadZip(detail.id)">
                        Download
                      </button>
                    </span>
                    <span v-else><b>Download Images:</b> </span>
                  </p>
                </div>
              </div>

              <!-- CLAIM METAS -->
              <div class="col-12" v-if="detail.product_id != 6">
                <table class="display table table-striped table-bordered" style="width:100%; text-align: center;">
                  <tr>
                    <th v-for="(item, index) in meta" v-bind:key="index">
                      {{ item.meta_label }}
                    </th>
                  </tr>
                  <tr>
                    <td v-for="(item, index) in meta" v-bind:key="index">
                      <span v-if="checkUpload(item.meta_value)">
                        <input type="button" value="View File" class="btn btn-primary" @click="openImage(item.id)" />
                      </span>

                      <span v-else-if="item.key != 'purchase_price'">
                        {{ item.meta_value | moment("Do MMMM YYYY") }}
                      </span>
                      <span v-else> {{ item.meta_value }}</span>
                    </td>
                  </tr>
                </table>
              </div>
              <hr v-if="detail.product_id == 6" />

              <div v-if="detail.product_id == 6" class="col-9 ">
                <table class="display table table-striped table-bordered" style="width:100%; text-align: center;">
                  <tr>
                    <th style="width: 100px;">No. </th>
                    <th>Person Covered</th>
                  </tr>
                  <tr>
                    <td style="background-color: rgb(240, 240, 240)">1</td>
                    <td style="background-color: rgb(240, 240, 240)" v-if="getPersonCovered">
                      {{ getPersonCovered.meta_value }}
                    </td>
                  </tr>
                </table>
              </div>
              <hr v-if="detail.product_id == 6" />
              <!-- Button -->
              <div class="row">
                <div class="col-12">
                  <button @click="void_claim(detail.id)" class="btn btn-lg btn-danger col-2"
                    v-if="detail.status_id == 10 && detail.product_id != 6">
                    Void Claim
                  </button>
                  <!-- in progress -->
                  <button @click="void_claim(detail.id)" class="btn btn-lg btn-danger col-2"
                    v-if="detail.product_id == 6 && !moment(detail.deadline_date).isSameOrAfter(moment(), 'day') && ![6, 4, 7, 12, 13, 14].includes(detail.status_id)">
                    Closed
                  </button>
                  <span class="mr-4"></span>

                  <button @click="reportedOnly(detail.id)" class="btn btn-lg btn-warning text-white  col-2 mr-4"
                    v-if="detail.status_id == 4 && detail.product_id != 6">
                    Report Only
                  </button>
                  <button @click="updateCounterDate(detail.id)" class="btn btn-lg btn-success col-2"
                    v-if="(detail.status_id == 10 && detail.product_id != 6)">Proceed
                  </button>
                  <button @click="proceedToProcess(detail.id)" class="btn btn-lg btn-success  col-2 ml-1"
                    v-if="(detail.status_id == 4) || ((detail.status_id == 10) && detail.product_id == 6 && moment(detail.deadline_date).isSameOrAfter(moment(), 'day'))">
                    {{ detail.status_id == 4 ? "Approve" : "Proceed" }}
                  </button>
                  <span class="mr-4"></span>
                  <button @click="reject_claim(detail.id)" class="btn btn-lg btn-danger col-2" v-if="
                    (
                      ![6, 7, 10, 13, 12, 14].includes(detail.status_id)
                    ) ||
                    (
                      ![6, 7, 10, 13, 12, 14].includes(detail.status_id) &&
                      detail.product_id == 6 &&
                      moment(detail.deadline_date).isSameOrAfter(moment(), 'day')
                    )
                  ">
                    {{ detail.product_id === 6 ? "Declined" : "Reject" }}

                  </button>

                  <!-- in progress -->
                  <button @click="updateDeadline(detail.id)" class="btn btn-lg btn-success col-2"
                    v-if="detail.product_id == 6 && !moment(detail.deadline_date).isSameOrAfter(moment(), 'day') && (detail.status_id == 10)">
                    Enable Upload Documents
                  </button>
                </div>
              </div>

              <div class="row"></div>

              <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="_documents" v-if="activeTab === '_documents'" role="tabpanel"
        aria-labelledby="profile-basic-tab">
        <DocumentClaim :data="detail" />
      </div>

      <div class="tab-pane fade" id="_approved" v-if="activeTab === '_approved'" role="tabpanel"
        aria-labelledby="profile-basic-tab">
        <ApprovedPage :data="detail" />
      </div>

      <div class="tab-pane fade" id="_declined" v-if="activeTab === '_declined'" role="tabpanel"
        aria-labelledby="profile-basic-tab">
        <DeclinedPage :data="detail" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import datepicker from "vuejs-datetimepicker";
import Profile from "@/views/contents/customers/Customer_profile.vue";
import DocumentClaim from "./tba-claim/DocumentClaim.vue";

import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import Document from "./tba-claim/DocumentClaim.vue";
import ApprovedPage from "./tba-claim/ApprovedPage.vue";
import DeclinedPage from "./tba-claim/DeclinedPage.vue";

export default {
  name: "tba_claim_details",
  components: {
    datepicker,
    DocumentClaim,
    ApprovedPage,
    Profile,
    Loading,
    DeclinedPage,
  },

  data() {
    return {
      counter_date: "",
      deadline_date: "",
      detail: [],
      profile: [],
      meta: [],
      void_remarks: null,
      isLoading: false,
      fullPage: true,
      moment,
      deadlineError: "",
      activeTab: '_details'
    };
  },

  computed: {
    getPersonCovered() {
      return this.detail.claims_meta.find(item => item.meta_key === 'person_covered') || null;
    }
  },

  watch: {
    deadline_date(newVal) {
      const currentDeadline = moment(this.detail.deadline_date).format("DD/MM/YYYY");
      if (newVal === currentDeadline) {
        return
      } else {
        this.handleDateChange(newVal)
      }
    }
  },

  methods: {
    setActive(tab) {
      this.activeTab = tab
    },
    loadDetails() {
      let token = localStorage.getItem("token");
      this.id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/tba/claim/show/" + this.id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.detail = res.data;
            this.meta = res.data.claims_meta;
            this.deadline_date = moment(res.data.deadline_date).format("DD/MM/YYYY");
          })
          .then(() => {
            this.loadProfile(token);
          });
      }
    },

    handleDateChange(value) {
      if (moment(this.detail.deadline_date).isSameOrAfter(moment(), 'day')) {
        this.updateDeadline(this.detail.id)
      } else {
        this.deadline_date = value
      }
    },

    loadProfile(token) {
      axios
        .get(
          axios.baseURL2 + "/customer?ic_number=" + this.detail.user.ic_number,
          {
            headers: {
              Authorization: "Bearer " + token
            }
          }
        )
        .then(res => {
          this.profile = res.data;
        });
    },

    proceedToProcess(detail_id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"]
        }).then(confirm => {
          if (confirm) {
            axios
              .post(
                "/claim/approve/" + detail_id,
                {
                  _method: "patch"
                },
                {
                  headers: {
                    Authorization: "Bearer " + token
                  }
                }
              )
              .then(res => {
                if (res.data.authorised == false) {
                  swal({
                    icon: "error",
                    text: res.data.message
                  });
                } else {
                  if (res.data.success == true) {
                    swal({
                      icon: "success",
                      text: res.data.message
                    })
                      .then(ok => {
                        this.$router.push({ name: "tba_claim" });
                      });
                  } else {
                    swal({
                      icon: "error",
                      text: res.data.message
                    });
                  }
                }
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled"
            });
          }
        });
      }
    },

    reportedOnly(detail_id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token == null) {
        swal({
          icon: "error",
          text: "You are unauthorised"
        });
        return;
      }

      token = JSON.parse(token);
      token = token.access_token;

      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (confirm) {
          axios
            .post(
              "/claim/report/" + detail_id,
              {
                _method: "patch"
              },
              {
                headers: {
                  Authorization: "Bearer " + token
                }
              }
            )
            .then(res => {
              if (res.data.authorised == false) {
                swal({
                  icon: "error",
                  text: res.data.message
                });
              } else {
                if (res.data.success == true) {
                  swal({
                    icon: "success",
                    text: res.data.message
                  }).then(ok => {
                    this.$router.push({ name: "tba_claim" });
                  });
                } else {
                  swal({
                    icon: "error",
                    text: res.data.message
                  });
                }
              }
            });
        } else {
          swal({
            icon: "info",
            text: "Cancelled"
          });
        }
      });
    },

    checkNull(string) {
      if (string == null) {
        return "";
      }
      return ", " + string;
    },

    downloadZip(claimID) {
      let token = localStorage.getItem("token");
      this.isLoading = true;
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post(
            "/claims/download",
            {
              claim_id: claimID
            },
            {
              headers: {
                Authorization: "Bearer " + token
              },
              responseType: "blob"
            }
          )
          .then(res => {
            this.isLoading = false;
            var fileURL = window.URL.createObjectURL(new Blob([res.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "claims_" + claimID + ".zip");
            document.body.appendChild(fileLink);
            fileLink.click();
          });
      }
    },

    updateCounterDate(id) {
      let token = localStorage.getItem("token");
      if (this.counter_date === "") {
        return swal({
          icon: "error",
          text: "Please enter date submit to counter"
        });
      }

      if (!this.checkingDate()) {
        return swal({
          icon: "error",
          text: "Submit to counter date must be within notification date."
        });
      }

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        axios
          .post(
            "claim/update/" + id,
            {
              counter_date: this.changeDateFormat(this.counter_date),
              _method: "patch"
            },
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.proceedToProcess(id);
          });
      }
    },

    updateDeadline(id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        if (this.deadline_date && this.deadline_date === "") {
          this.deadlineError = "Deadline date is required."
          return swal({
            icon: "error",
            text: "Please enter deadline date"
          });
        }
        token = JSON.parse(token);
        token = token.access_token;
        axios
          .post(
            "claim/update/" + id + "/deadline",
            {
              deadline_date: this.changeDateFormat(this.deadline_date),
              _method: "post"
            },
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            if (res.data.success == true) {
              swal({
                icon: "success",
                text: res.data.message
              })
                .then(ok => {
                  this.$router.push({ name: "tba_claim" });
                });
            } else {
              swal({
                icon: "error",
                text: res.data.message
              })
            }
            // this.proceedToProcess(id);
          });
      }
    },

    /**
     * input format DD/MM/YYYY
     * output YYYY-MM-DD
     */
    changeDateFormat(date) {
      let newdate = date.split("/");

      return newdate[2] + "-" + newdate[1] + "-" + newdate[0];
    },

    reject_claim(detail_id) {
      let token = localStorage.getItem("token");

      //check if has token
      if (token != null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"]
        }).then(confirm => {
          if (confirm) {
            axios
              .post(
                "/claim/reject/" + detail_id,
                {
                  _method: "patch"
                },
                {
                  headers: {
                    Authorization: "Bearer " + token
                  }
                }
              )
              .then(res => {
                if (res.data.authorised == false) {
                  swal({
                    icon: "error",
                    text: res.data.message
                  });
                } else {
                  if (res.data.success == true) {
                    swal({
                      icon: "success",
                      text: res.data.message
                    }).then(ok => {
                      this.$router.push({ name: "tba_claim" });
                    });
                  } else {
                    swal({
                      icon: "error",
                      text: res.data.message
                    });
                  }
                }
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled"
            });
          }
        });
      }
    },

    void_claim(detail_id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token == null) {
        swal({
          icon: "error",
          text: "You are unauthorised"
        });
        return;
      }

      token = JSON.parse(token);
      token = token.access_token;

      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (confirm) {
          axios
            .post(
              "/claim/void/" + detail_id,
              {
                void_remarks: this.void_remarks,
                _method: "patch"
              },
              {
                headers: {
                  Authorization: "Bearer " + token
                }
              }
            )
            .then(res => {
              if (res.data.authorised == false) {
                swal({
                  icon: "error",
                  text: res.data.message
                });
              } else {
                if (res.data.success == true) {
                  swal({
                    icon: "success",
                    text: res.data.message
                  }).then(ok => {
                    this.$router.push({ name: "tba_claim" });
                  });
                } else {
                  swal({
                    icon: "error",
                    text: res.data.message
                  });
                }
              }
            });
        } else {
          swal({
            icon: "info",
            text: "Cancelled"
          });
        }
      });
    },

    closeClaim(detail_id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token == null) {
        swal({
          icon: "error",
          text: "You are unauthorised"
        });
        return;
      }

      token = JSON.parse(token);
      token = token.access_token;

      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (confirm) {
          axios
            .post(
              "/claim/update/" + detail_id,
              {
                status_id: 5, // completed might need to change
                _method: "patch"
              },
              {
                headers: {
                  Authorization: "Bearer " + token
                }
              }
            )
            .then(res => {
              if (res.data.authorised == false) {
                swal({
                  icon: "error",
                  text: res.data.message
                });
              } else {
                if (res.data.success == true) {
                  swal({
                    icon: "success",
                    text: res.data.message
                  }).then(ok => {
                    this.$router.push({ name: "tba_claim" });
                  });
                } else {
                  swal({
                    icon: "error",
                    text: res.data.message
                  });
                }
              }
            });
        } else {
          swal({
            icon: "info",
            text: "Cancelled"
          });
        }
      });
    },

    checkingDate() {
      let counter_date = this.counter_date;
      counter_date = counter_date
        .split("/")
        .reverse()
        .join("-");

      let notification_date = moment(this.detail.created_at).format(
        "YYYY-MM-DD"
      );
      let selected = moment(counter_date).format("YYYY-MM-DD");

      if (selected < notification_date) {
        return false;
      }
      return true;
    },

    checkUpload(str) {
      let type = str
        .split(".")
        .pop()
        .toLowerCase();
      if (type == "jpeg" || type == "png" || type == "jpg" || type == "pdf") {
        return true;
      }

      if (type == "mp4" || type == "mp3") {
        return undefined;
      }
    },

    openImage(id) {
      this.isLoading = true;
      let token = localStorage.getItem("token");
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        axios
          .get("/download/" + id, {
            headers: {
              Authorization: "Bearer " + token
            },
            responseType: "blob"
          })
          .then(res => {
            console.log(res);
            this.isLoading = false;
            let type = "image/x-png, image/gif, image/jpeg, image/jpg";

            let blob = new Blob([res.data], { type: type }),
              url = window.URL.createObjectURL(blob);

            window.open(url);
          });
      }
    }
  },

  mounted() {
    this.loadDetails();
  }
};
</script>
